export const HOME_FETCH_ALL_LG_BEGIN = "HOME_FETCH_ALL_LG_BEGIN"
export const HOME_FETCH_ALL_LG_SUCCESS = "HOME_FETCH_ALL_LG_SUCCESS"
export const HOME_FETCH_ALL_LG_FAILURE = "HOME_FETCH_ALL_LG_FAILURE"
export const HOME_FETCH_ALL_LG_DISMISS_ERROR = "HOME_FETCH_ALL_LG_DISMISS_ERROR"
export const HOME_FETCH_LG_DETAIL_BEGIN = "HOME_FETCH_LG_DETAIL_BEGIN"
export const HOME_FETCH_LG_DETAIL_SUCCESS = "HOME_FETCH_LG_DETAIL_SUCCESS"
export const HOME_FETCH_LG_DETAIL_FAILURE = "HOME_FETCH_LG_DETAIL_FAILURE"
export const HOME_FETCH_LG_DETAIL_DISMISS_ERROR = "HOME_FETCH_LG_DETAIL_DISMISS_ERROR"
export const HOME_UPDATE_CURRENT_LOCATION_BEGIN = "HOME_UPDATE_CURRENT_LOCATION_BEGIN"
export const HOME_UPDATE_CURRENT_LOCATION_SUCCESS = "HOME_UPDATE_CURRENT_LOCATION_SUCCESS"
export const HOME_UPDATE_CURRENT_LOCATION_FAILURE = "HOME_UPDATE_CURRENT_LOCATION_FAILURE"
export const HOME_UPDATE_CURRENT_LOCATION_DISMISS_ERROR = "HOME_UPDATE_CURRENT_LOCATION_DISMISS_ERROR"
export const HOME_UPDATE_MAP_PROPS = "HOME_UPDATE_MAP_PROPS"



// WEBPACK FOOTER //
// ./src/features/home/redux/constants.js